var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PgFilePreviewDialog,{attrs:{"visible":_vm.value,"value":_vm.data,"current":_vm.item},on:{"update:visible":_setup.updateVisible}})
}
var staticRenderFns = []

export { render, staticRenderFns }